export default "__VITE_ASSET__674ce87e__"